import { PricingTable, PricingTableShow } from './PricingTable'
import { ModalV2 } from './Common/ModalV2'
import { useProjectStore } from 'store/useProjectStore'
import { useUserPlan } from 'hooks/useUserPlan'
import { useMediaQuery } from '@uidotdev/usehooks'

export const PricingTableModal = ({
  isLoading,
  show,
  onSelectPlan,
  isTrialing,
  setShowUpgradeTrialModal,
  setShowPricingModal,
  showPricingModal = false,
}: {
  onSelectPlan?: ({ id, name }: { id: string; name: string }) => void
  isLoading: boolean
  show: PricingTableShow
  isTrialing?: boolean
  setShowUpgradeTrialModal?: (show: boolean) => void
  showPricingModal?: boolean
  setShowPricingModal?: (show: boolean) => void
}) => {
  const { planId } = useUserPlan()
  const { setSelectedPlanId } = useProjectStore()

  const handleSelectPlan = ({ id, name }: { id: string; name: string }) => {
    setSelectedPlanId(id)
    if (onSelectPlan) {
      onSelectPlan({ id, name })
    }
  }

  return (
    <ModalV2
      className="w-full md:max-w-6xl"
      open={showPricingModal}
      onClose={() => setShowPricingModal?.(false)}
      preventClose
      includeCloseButton
    >
      <PricingTable
        condensed={false}
        show={show}
        currentPlan={planId as any}
        isLoadingBillingSession={isLoading}
        onSelectPlan={handleSelectPlan}
        isTrialing={isTrialing}
        setShowUpgradeTrialModal={setShowUpgradeTrialModal}
      />
    </ModalV2>
  )
}
